import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'

export const useUser = defineStore('user', {
  state: () => ({}),
  actions: {
    /**
     * 用户管理
     */
    // 获取用户分页列表
    async getUserPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/page`,
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增用户
    async userAdd(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/add`,
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 用户配置角色权限
    async changeConfRoleId(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/confRoleId`,
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 查询用户详情
    async getUserDetail(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/info/${id}`,
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除用户
    async userDel(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/del/${id}`,
          method: 'post'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 禁用启用用户
    async userFreeze(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/freeze`,
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
